/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { ImageLoader } from '../ImageLoader';
import { ImageLoaderTypes } from '../ImageLoader/ImageLoaderTypes';
import { DeviceModel } from '../../core/device/DeviceModel';
import { RootState } from '../../store/root.reducers';
import { NoNetworkOverlay } from '../NoNetworkOverlay';

import tivoBrandingImg from '../../assets/images/1080p/splash-powered-by-tivo-en-405-x-81-1080-p.png';
import tivoBrandingImg720p from '../../assets/images/720p/splash-powered-by-tivo-en-270-x-54-720-p.png';

import './SplashScreen.scss';

const SplashScreen: FunctionComponent = (): JSX.Element => {
    const partnerBrandingImageUrl = useSelector(
        (state: RootState) => state.appl.partnerBrandingImageUrl,
    );
    return (
        <React.Fragment>
            <NoNetworkOverlay />
            <div className="splash-screen-container">
                <div className="partner-branding">
                    <ImageLoader
                        src={partnerBrandingImageUrl}
                        imageType={ImageLoaderTypes.SPLASH_SCREEN_PARTNER_BRANDING}
                    />
                </div>
                <img
                    className="tivo-branding"
                    src={DeviceModel.is1080P() ? tivoBrandingImg : tivoBrandingImg720p}
                />
            </div>
        </React.Fragment>
    );
};

export default SplashScreen;
